<template>
    <div class="input--label">
    <label v-html="label">
    </label>
    <span v-if="required" class="input__asterisk">*</span>
    </div>
</template>

<script>
  export default {
    name: 'inputLabelFullWidth',
    props: [
      'label',
      'required'
    ]
  }
</script>



// WEBPACK FOOTER //
// inputLabelFullWidth.vue?2039f882